import { render, staticRenderFns } from "./comp_Carousel.vue?vue&type=template&id=dfaa7d86&scoped=true"
import script from "./comp_Carousel.vue?vue&type=script&lang=js"
export * from "./comp_Carousel.vue?vue&type=script&lang=js"
import style0 from "./comp_Carousel.vue?vue&type=style&index=0&id=dfaa7d86&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfaa7d86",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
